import Vue from 'vue';
import VueRouter from 'vue-router';
import Chat from '../views/Chat.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'main',
    component: Chat,
  },
  {
    path: '/history',
    name: 'history',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/History.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
